import axios from 'axios';
import { getField, updateField } from 'vuex-map-fields';

const url = 'https://api.bi-assobens.com.br/v1';
// const url = 'http://localhost:3000/v1';

export default {
  namespaced: true,
  state: {
    demands: [],
    totalDemand: 0,
  },
  mutations: {
    updateField,
    SET_STOCK_DEMAND(state, payload) {
      state.demands = payload.procura;
      state.totalDemand = payload.total;
    },
  },
  actions: {
    // eslint-disable-next-line no-unused-vars
    async getStockDemand({ commit }, obj) {
      const { data } = await axios.get(`${url}/list-procura`, {
        params: {
          // page: obj.page,
          // limit: obj.limit,
          filter: obj.filter ? obj.filter : null,
        },
      });
      commit('SET_STOCK_DEMAND', data);
    },
    // eslint-disable-next-line no-unused-vars
    async createStockDemand({ commit }, obj) {
      await axios.post(
        `${url}/create-procura`,
        { ...obj.data },
        { headers: { 'x-access-token': obj.data.token } },
      );
    },
    // eslint-disable-next-line no-unused-vars
    async removeStockDemand({ commit }, obj) {
      await axios.delete(
        `${url}/remove-procura`,
        { data: { ...obj } },
        { headers: { 'x-access-token': obj.token } },
      );
    },
    // eslint-disable-next-line no-unused-vars
    async updateStockDemand({ commit }, obj) {
      await axios.put(
        `${url}/update-procura/${obj.id}`,
        { ...obj },
        {
          headers: { 'x-access-token': obj.token },
        },
      );
    },
  },
  getters: { getField },
};
